module.exports = __webpack_public_path__ + "media/club/be_save_serial-da50f672.webp";